import { jsx as _jsx } from "react/jsx-runtime";
import { generateAemConfiguration } from '@as-react/common-utils';
import { createContext, useContext } from 'react';
export const AemConfigurationContext = createContext({});
export const useAemConfig = () => useContext(AemConfigurationContext);
export const AemConfigurationContextWrapper = ({ children, value }) => (_jsx(AemConfigurationContext.Provider, { value: generateAemConfiguration(value), children: children }));
//# sourceMappingURL=AemConfigurationContext.js.map